import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import { useAppState } from "@/services/Composition";
import frames from "@/utils/frameToTime";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Home',
    setup(__props) {
        const { state, send } = useAppState();
        const isLanding = computed(() => state.value.matches("home.landing"));
        const isHomePage = computed(() => state.value.matches("home.home.page"));
        async function onAfterEnterLanding() {
            send("NEXT");
        }
        return (_ctx, _cache) => {
            const _component_HomePage = _resolveComponent("HomePage");
            const _component_HomeLanding = _resolveComponent("HomeLanding");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createVNode(_component_HomePage, null, null, 512), [
                    [_vShow, isHomePage.value]
                ]),
                _createVNode(_component_HomeLanding, {
                    show: isLanding.value,
                    delay: _unref(frames)(70),
                    onAfterEnter: onAfterEnterLanding
                }, null, 8, ["show", "delay"])
            ], 64));
        };
    }
});
